module.exports = __webpack_public_path__ + "img/ava-7.559363c5.webp";